/// <reference types="vite/client" />

/**
 * Read a Vite environment variable. Throws in production if the value is missing.
 * In development, returns an empty string for missing values (fail-soft for DX).
 */
export function getRequiredEnv(key: string): string {
  const value = import.meta.env[key];
  if (!value && import.meta.env.PROD) {
    throw new Error(`Missing required environment variable: ${key}`);
  }
  return value ?? '';
}
